import { Button, Popover, Radio, Space } from 'antd';
import { UnorderedListOutlined } from '@ant-design/icons';
import { useUnit } from 'effector-react';
import style from './CenterHomeLayerDropdown.module.css';
import {
  $hexProp,
  changeHexPropEv,
} from '../../models/centerHomeModel/index.js';

function CenterHomeLayerDropdown() {
  const hexProp = useUnit($hexProp);
  const changeHexProp = useUnit(changeHexPropEv);

  const popoverContent = (
    <div>
      <div className={style.popover_title}>Стоимости квартир:</div>
      <Radio.Group
        value={hexProp}
        onChange={(e) => changeHexProp(e.target.value)}
      >
        <Space direction="vertical">
          <Radio style={{ fontFamily: 'Gilroy' }} value="room1_hex_mean">
            Однокомнатных
          </Radio>
          <Radio style={{ fontFamily: 'Gilroy' }} value="room2_hex_mean">
            Двухкомнатных
          </Radio>
          <Radio style={{ fontFamily: 'Gilroy' }} value="room3_hex_mean">
            Трехкомнатных
          </Radio>
          <Radio style={{ fontFamily: 'Gilroy' }} value="room4_hex_mean">
            Четырех - и более комнатных
          </Radio>
        </Space>
      </Radio.Group>
    </div>
  );

  return (
    <Popover content={popoverContent} trigger="click" placement="left">
      <Button
        className={style.layer_dropdown}
        icon={<UnorderedListOutlined />}
      />
    </Popover>
  );
}

export default CenterHomeLayerDropdown;
